import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FolderPermissionsResponse } from '../../../../../../../api/types.gen';
import { PeoplePicker } from '../../../../../../Core/PeoplePicker';
import { IPermissionsDialogForm } from '../../../PermissionsDialogForm';
import { PermissionsField } from '../PermissionsField';

interface IPermissionsPersonPickerProps {
  folderInfo: FolderPermissionsResponse;
}

export function PermissionsPersonPicker({ folderInfo }: IPermissionsPersonPickerProps) {
  const { t } = useTranslation();
  const { control, watch } = useFormContext<IPermissionsDialogForm>();
  const isEditMode = watch('isEditMode');
  return (
    <PermissionsField label={t('permissions.modifyAction.personGroup.label')}>
      <Controller
        control={control}
        name="users"
        render={({ field: { value, onChange } }) => (
          <PeoplePicker selectedPeople={value} onSelect={onChange} isDisabled={isEditMode} folderInfo={folderInfo} />
        )}
      />
    </PermissionsField>
  );
}
